export type Testimonial = {
  quote: string;
  name: string;
  role: string;
};
export type MapBlock = {
  icon: 'book' | 'scroll';
  title: string;
  description: string;
};
export type Bonus = {
  label: string;
  title: string;
  subtitle: string;
  description: string;
  value: string;
  image: string;
};
export type Faq = {
  question: string;
  answer: string;
};
export const trustStats = [{
  value: "2.000+",
  label: 'católicos confían'
}, {
  value: '5',
  label: 'materiales incluidos'
}, {
  value: '73',
  label: 'libros mapeados'
}, {
  value: '4.9/5',
  label: 'calificación'
}];
export const featuredTestimonials: Testimonial[] = [{
  quote: 'Finalmente entiendo cómo se conectan todos los libros. Usé GPS Bíblico en mi grupo de catequesis y todos comprenden mejor el contexto de cada lectura.',
  name: 'María G.',
  role: 'Catequista · Ciudad de México, México'
}, {
  quote: 'Como líder de grupo bíblico, esto cambió todo. Los mapas visuales me permiten guiar a mis hermanos sin confundirme entre profetas, reyes e historias.',
  name: 'Carlos L.',
  role: 'Líder Comunitario · Bogotá, Colombia'
}];
export const testimonials: Testimonial[] = [{
  quote: 'Empecé a leer la Biblia hace poco y no sabía dónde comenzar. GPS Bíblico me mostró que todo tiene un orden lógico. Ahora leo cada día sin confusión.',
  name: 'Javier P.',
  role: 'Madrid, España'
}, {
  quote: 'Como mamá, quería enseñarles a mis hijos sobre la Biblia, pero me sentía perdida. Los mapas de GPS Bíblico me dieron la confianza que necesitaba.',
  name: 'Analía M.',
  role: 'Lima, Perú'
}, {
  quote: 'Usé GPS Bíblico en mi grupo de catequesis. Los jóvenes preguntan más, comprenden mejor y quieren seguir estudiando. Cambió por completo la dinámica.',
  name: 'Sandra L.',
  role: 'Guadalajara, México'
}, {
  quote: 'El Plan Ruta Bíblica 365 me dio la estructura que necesitaba. Llevo 4 meses leyendo sin saltarme un día y por fin veo la Biblia como un todo coherente.',
  name: 'Roberto F.',
  role: 'Buenos Aires, Argentina'
}, {
  quote: 'Soy diácono y los uso para preparar las homilías. Ubicar cada lectura dentro de la Historia de la Salvación me ahorra horas de estudio.',
  name: 'Andrés T.',
  role: 'Santiago, Chile'
}, {
  quote: 'Lo compartimos en la parroquia y fue un antes y un después. Nunca habíamos visto material católico tan claro y tan fácil de explicar.',
  name: 'Gabriela S.',
  role: 'Guayaquil, Ecuador'
}];
export const painPoints = ['Te perdés entre nombres, genealogías y contextos históricos que no terminás de entender.', 'Querés leer todo, pero no sabés por dónde empezar ni en qué orden tiene sentido.', 'Intentás seguir un plan de lectura, pero lo abandonás porque se vuelve monótono.', 'Sin una guía clara, la Biblia se siente como un laberinto, no como una ruta.'];
export const whyTraditionalFails = [{
  title: 'Lectura lineal sin contexto',
  description: 'Leer libro tras libro sin entender cómo se conectan es como manejar sin GPS: llegás a destino, pero confundido.'
}, {
  title: 'Material católico específico es raro',
  description: 'La mayoría de las guías son genéricas o de otras tradiciones. GPS Bíblico está diseñado para los 73 libros del canon católico.'
}, {
  title: 'Los estudios académicos abruman',
  description: 'Comentarios largos y complejos terminan desalentando a quien quiere estudiar de forma práctica.'
}, {
  title: 'Falta un sistema visual',
  description: 'Sin mapas, esquemas y conexiones claras, cada libro se siente aislado. GPS Bíblico une todo con una lógica clara.'
}];
export const systemAnswers = [{
  label: 'Dónde estás',
  description: 'En qué período de la Historia de la Salvación te encontrás.'
}, {
  label: 'Qué estás leyendo',
  description: 'El propósito central del libro, en una sola mirada.'
}, {
  label: 'Por qué importa',
  description: 'Qué enseña este libro que no dicen los otros.'
}, {
  label: 'Cómo se conecta',
  description: 'Su relación con el Nuevo Testamento y con Jesús.'
}];
export const mainProduct = {
  title: 'Los Mapas de la Biblia Católica',
  description: 'Un mapa mental por cada uno de los 73 libros, agrupados en dos packs: Antiguo y Nuevo Testamento. En una sola hoja ves quién escribió el libro, para qué fue escrito, sus temas, su estructura y qué significa hoy para tu fe.',
  image: 'https://cdn.magicpatterns.com/uploads/aq86eDyGnGZLTCzKenP8oQ/heylloyd-image-1789332845228.png',
  imageAlt: 'Mapas Visuales del Antiguo y del Nuevo Testamento de GPS Bíblico'
};
export type MapSlide = {
  book: string;
  block: string;
  image: string;
};
export const mapSlides: MapSlide[] = [{
  book: 'Génesis',
  block: 'Pentateuco · Antiguo Testamento',
  image: 'https://cdn.magicpatterns.com/uploads/8c1UvMpXhtHB4UxBEXj53X/Captura_de_pantalla_2026-09-13_202538.png'
}, {
  book: 'Ester',
  block: 'Libros Históricos · Antiguo Testamento',
  image: 'https://cdn.magicpatterns.com/uploads/fQ4LHNjLSDWHob2mgDqdHy/Captura_de_pantalla_2026-09-13_202609.png'
}, {
  book: 'Proverbios',
  block: 'Poéticos y Sapienciales · Antiguo Testamento',
  image: 'https://cdn.magicpatterns.com/uploads/cAhF5jV7TndHx14oYDPHZP/Captura_de_pantalla_2026-09-13_202630.png'
}, {
  book: 'Sabiduría',
  block: 'Poéticos y Sapienciales · Antiguo Testamento',
  image: 'https://cdn.magicpatterns.com/uploads/nay79ctEaokAyg3dckWgUR/Captura_de_pantalla_2026-09-13_202649.png'
}, {
  book: 'Mateo',
  block: 'Evangelios · Nuevo Testamento',
  image: 'https://cdn.magicpatterns.com/uploads/87xhcHM2Y4ZiaqwViww2dY/Captura_de_pantalla_2026-09-13_202446.png'
}, {
  book: '2 Corintios',
  block: 'Cartas Paulinas · Nuevo Testamento',
  image: 'https://cdn.magicpatterns.com/uploads/qBxu1fQQvYyV7yjygWNNcL/Captura_de_pantalla_2026-09-13_202710.png'
}, {
  book: 'Apocalipsis',
  block: 'Profético · Nuevo Testamento',
  image: 'https://cdn.magicpatterns.com/uploads/wC3HRCf8xp4q32Pz4AHcex/Captura_de_pantalla_2026-09-13_202730.png'
}];
export const mapBlocks: MapBlock[] = [{
  icon: 'book',
  title: 'Antiguo Testamento · 46 mapas',
  description: 'Un mapa por libro, ordenados por bloques: Pentateuco, Históricos, Poéticos y Sapienciales, y Proféticos. Cada bloque se identifica con su etiqueta para que sepas siempre dónde estás parado.'
}, {
  icon: 'scroll',
  title: 'Nuevo Testamento · 27 mapas',
  description: 'Evangelios, Hechos, Cartas Paulinas, Cartas Generales y Apocalipsis. Cada mapa muestra cómo Jesús cumple lo prometido en el Antiguo Testamento y cómo vive la Iglesia.'
}];
export const mapFeatures = ['¿Quién lo escribió? y en qué contexto', 'Propósito central del libro', 'Temas principales, resumidos', 'Estructura del libro por capítulos', 'Versículo clave explicado', 'Interpretación e impacto en la fe'];
export const bonuses: Bonus[] = [{
  label: 'Bono 1',
  title: 'Guía de Navegación Visual',
  subtitle: 'Cómo usar los mapas mentales para comprender los 73 libros',
  description: 'El manual que te enseña a leer cada mapa conceptual: qué mirar primero, qué preguntas hacerte al abrir un libro y cómo conectar unos con otros sin perderte.',
  value: "$29 usd",
  image: 'https://cdn.magicpatterns.com/uploads/wiBvPGMTkzfeVnSRRDxmNy/heylloyd-image-1789329039469.png'
}, {
  label: 'Bono 2',
  title: 'Ruta Bíblica 365',
  subtitle: 'Plan católico para leer los 73 libros en un año',
  description: 'Una guía anual con lectura diaria y orden teológico, para ir marcando los libros que vas leyendo y ver tu avance durante todo el año.',
  value: "$10 usd",
  image: 'https://cdn.magicpatterns.com/uploads/giw2qFbGDGbawJFytUBzDx/heylloyd-image-1789330570864.png'
}, {
  label: 'Bono 3',
  title: '7 Días para Entender Mejor la Biblia',
  subtitle: 'Mini guía de inicio rápido para comprender la Biblia en una semana',
  description: 'Un recorrido en 7 días, desde el panorama general de la Biblia hasta los Evangelios, las cartas y el Apocalipsis. Cada día con una explicación breve y una lectura concreta.',
  value: '$14 usd',
  image: 'https://cdn.magicpatterns.com/uploads/nAqxsbJGL1928FNgPBm7nu/heylloyd-image-1789567901572.png'
}, {
  label: 'Bono 4',
  title: 'Guía de Símbolos Bíblicos Esenciales',
  subtitle: 'Agua, luz, fuego, pan, desierto, monte, cordero, pastor, viña y templo',
  description: 'Mini guía visual que explica los símbolos más repetidos en la Biblia, para comprender el lenguaje simbólico y leer con más profundidad sin complicarte.',
  value: '$10 usd',
  image: 'https://cdn.magicpatterns.com/uploads/j7GXio7hKxmRtsELZUoKB2/heylloyd-image-1789570588006.png'
}];
export const forYou = ['Sos católico y querés profundizar tu fe', 'Catequista o coordinador de grupo bíblico', 'Empezás a leer la Biblia por primera vez', 'Ya leés, pero te sentís desordenado'];
export const notForYou = ['Buscás análisis académico profundo', 'Necesitás comentarios versículo por versículo', 'Preferís estudios de otras tradiciones cristianas'];
export const priceIncludes = ['Acceso 100% digital inmediato', 'Los 73 mapas en PDF descargable', 'Compatible con celular, tablet, computadora e impresión', 'Incluye los 4 bonos de regalo (valor USD 63)', 'Garantía de 7 días sin preguntas'];
export const withoutGps = ['Horas buscando en internet "cómo entender este libro"', 'Confusión constante sobre el orden y la conexión de los libros', 'Miedo a guiar mal a otros en grupos bíblicos', 'Lectura lenta y fragmentada: nunca ves el cuadro completo', 'Abandono de los planes de lectura anual', 'El mismo ciclo, año tras año'];
export const withGps = ['Cada libro tiene sentido dentro de un sistema coherente', 'Navegás con confianza: sabés dónde estás en la Historia de la Salvación', 'Guiás a otros con claridad: sos referencia, no guía perdida', 'Un plan de lectura anual que sí mantenés', 'Estudiás con tu familia, tu grupo y tu comunidad de forma ordenada', 'Tu fe crece porque entendés mejor el mensaje bíblico completo'];
export const faqs: Faq[] = [{
  question: '¿Es 100% católico? ¿Incluye los 73 libros?',
  answer: 'Sí. GPS Bíblico mapea exactamente los 73 libros del canon católico: 46 del Antiguo Testamento y 27 del Nuevo Testamento. Está diseñado específicamente para la tradición católica.'
}, {
  question: '¿Es físico o digital?',
  answer: '100% digital en PDF. Lo recibís por correo en menos de 5 minutos. Podés descargarlo a tu computadora, leerlo en celular o tablet, o imprimirlo para estudiar en papel.'
}, {
  question: '¿Necesito saber mucho de Biblia para entenderlo?',
  answer: 'No. GPS Bíblico está diseñado tanto para principiantes como para personas con más experiencia. La Guía de Navegación Visual te enseña paso a paso cómo usar los mapas mentales.'
}, {
  question: '¿Puedo usarlo para catequesis o grupos bíblicos?',
  answer: 'Sí. De hecho, muchos catequistas y líderes de grupo ya lo usan. Los mapas visuales facilitan muchísimo explicar a otros y son ideales para dinámicas grupales.'
}, {
  question: '¿Reemplaza a la Biblia o a otros libros de estudio?',
  answer: 'No. GPS Bíblico es una guía de navegación: te ayuda a entender la estructura y el propósito de cada libro bíblico. Siempre vas a necesitar leer la Biblia directamente.'
}, {
  question: '¿Cuánto tiempo tengo acceso?',
  answer: 'De por vida. Una vez que lo comprás, el PDF es tuyo para siempre. Podés descargarlo, imprimirlo y compartirlo con tu grupo según la licencia de uso.'
}];
export const heroImage = 'https://cdn.magicpatterns.com/uploads/r8zpQYrCkvJ1Bo1NCTAKnw/heylloyd-image-1789588058260.png';
export type BlockChip = {
  label: string;
  books: string;
  color: string;
};
export const blockChips: BlockChip[] = [{
  label: 'Pentateuco',
  books: '5 libros',
  color: '#4aa3c7'
}, {
  label: 'Históricos',
  books: '16 libros',
  color: '#5aa36b'
}, {
  label: 'Sapienciales',
  books: '7 libros',
  color: '#c08c33'
}, {
  label: 'Proféticos',
  books: '18 libros',
  color: '#8f6fc0'
}, {
  label: 'Evangelios',
  books: '4 libros',
  color: '#c97a3c'
}, {
  label: 'Hechos y Cartas',
  books: '22 libros',
  color: '#b4544a'
}, {
  label: 'Apocalipsis',
  books: '1 libro',
  color: '#6b7890'
}];
export const heroBadges = ['100% PDF', 'Acceso al instante', '73 libros mapeados', 'Canon católico'];
export const painIntro = 'Sos católico y querés leer la Biblia. Pero nadie te explicó cómo se conectan los 73 libros, y cada vez que abrís uno terminás buscando en internet "qué significa este pasaje".';
export const painClaim = 'No es falta de fe. Es falta de un sistema.';
export const bonusesTotalValue = 'USD 63';
export const checkoutUrl = 'https://gps-biblico.impultienda.ar/checkout';
export const launchOffer = {
  regularPrice: 'USD 79.90',
  price: 'USD 17',
  arsReference: 'Equivalente a ~$15.000 ARS según la cotización del día',
  increaseWarning: 'Después vuelve a USD 79.90',
  cuposPercent: 68,
  cuposLabel: '68% de los cupos al precio de lanzamiento ya tomados'
};
export type VerifiedPurchase = {
  name: string;
  city: string;
  time: string;
};
export const verifiedPurchases: VerifiedPurchase[] = [{
  name: 'Andrea V.',
  city: 'Monterrey, México',
  time: 'hace 2 minutos'
}, {
  name: 'Gustavo R.',
  city: 'Medellín, Colombia',
  time: 'hace 11 minutos'
}, {
  name: 'Lucía F.',
  city: 'Sevilla, España',
  time: 'hace 24 minutos'
}, {
  name: 'Miguel Á.',
  city: 'Lima, Perú',
  time: 'hace 38 minutos'
}, {
  name: 'Carmen D.',
  city: 'Santiago, Chile',
  time: 'hace 52 minutos'
}, {
  name: 'José M.',
  city: 'San Salvador, El Salvador',
  time: 'hace 1 hora'
}];